import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { CollaborationApiService } from '../../../../services/api/collaboration-api.service';
import { DeclineAccessRequest } from '../../../../models/dtos';
import { firstValueFrom } from 'rxjs';
import { UserProfileService } from '../../../../services/common/user-profile.service';
import { CONSTANTS } from '../../../../Constants/Constants';
import { IAccessRequestDeclineFormGroup } from '../../../../models/collaboration/IAccessRequestDeclineFormGroup';
import { IAccessRequestDeclineDialogData } from '../../../../models/collaboration/IAccessRequestDeclineDialogData';

@Component({
  selector: 'app-access-request-decline-dialog',
  imports: [
    TranslatePipe,
    MatButtonModule,
    MatLabel,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDialogModule,
  ],
  templateUrl: './access-request-decline-dialog.html',
  styleUrl: './access-request-decline-dialog.scss'
})
export class AccessRequestDeclineDialog implements OnInit {

  declineFormGroup!: FormGroup<IAccessRequestDeclineFormGroup>;

  constructor(
    public dialogRef: MatDialogRef<AccessRequestDeclineDialog>,
    private readonly fb: NonNullableFormBuilder,
    private readonly collaborationApiService: CollaborationApiService,
    private readonly userProfileService: UserProfileService,
    @Inject(MAT_DIALOG_DATA) public data: IAccessRequestDeclineDialogData
  ) { }

  ngOnInit(): void {
    this.declineFormGroup = this.fb.group<IAccessRequestDeclineFormGroup>({
      declineNotes: this.fb.control<string>('', Validators.required),
    });
  }

  async decline(): Promise<void> {
    if (this.declineFormGroup.invalid) {
      return;
    }

    const request: DeclineAccessRequest = {
      editorEmail: this.userProfileService.userInfo?.mail ?? CONSTANTS.EMPTY_STRING,
      declineNotes: this.declineFormGroup.controls.declineNotes?.value ?? CONSTANTS.EMPTY_STRING,
      requestorEmails: this.data.requestorEmails,
    };

    try{
      await firstValueFrom(this.collaborationApiService.declineAccessRequest(request));
      this.dialogRef.close({ action: 'declined' });
    }
    catch (error) {
      console.error('Error declining access request:', error);
    }
  }
}
